module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "reassignment-form",
    attrs: {
      "itemsFormActivityReassignment": _vm.itemsFormActivityReassignment,
      "resource": _vm.itemResource,
      "typeactivity": _vm.typeactivity
    },
    on: {
      "change": _vm.changelist
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Reasignar PQR")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddbd16a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-reassignment.vue
// module id = 200
// module chunks = 0